<span
  class="ml-1.5 inline whitespace-nowrap rounded-full bg-white bg-opacity-20 px-1.5 text-center text-xs font-bold leading-5"
  ><slot /></span
>
